import React from "react";

import { NavigationTab } from "./NavigationTab";
import { Tab } from "./types";

type Props = {
  tabs: Tab[];
};

export const NavigationTabs: React.FC<Props> = ({ tabs }) => {
  return (
    // Phones (QA batch 11): the tab bar scrolls sideways instead of cutting
    // the last tabs off.
    <div
      className={
        "flex gap-[30px] border-b border-[#E4E7EC] max-md:overflow-x-auto max-md:overflow-y-hidden"
      }>
      {tabs.map((tab, index) => (
        <NavigationTab tab={tab} key={index} />
      ))}
    </div>
  );
};
